<iframe
  *ngIf="doAttempt"
  id="ncarbIframe"
  [src]="ncarbSilentLoadUrl | safeUrl"
  allowfullscreen
  [class.d-none]="!isVisible"
  [class.shown]="isVisible"
></iframe>
